// @flow
export { default } from './PartnerLikeButton';



// WEBPACK FOOTER //
// ./src/components/partner/PartnerLikeButton/index.js